import { useImage } from '../../utils/customHooks/useImage';
import userAvatar from '../../assets/icons/silhouette--dark.svg';
import groupAvatar from '../../assets/icons/silhouette-with-three.svg';
import { PlaceHolderWrapper, SImg } from './ProfilePicture.styles';

type ProfilePictureProps = {
  profilePictureFileName?: string | null;
  readyPhotoSource?: string;
  isGroup?: boolean;
  diameter?: number;
  zIndex?: number;
};

export const ProfilePicture = (props: ProfilePictureProps) => {
  const { readyPhotoSource, profilePictureFileName = null, isGroup, diameter = 45, zIndex } = props;

  const { img, isImageLoading } = useImage({
    imageName: profilePictureFileName,
    size: 'small',
  });

  if (readyPhotoSource)
    return (
      <SImg
        role="profilePicture"
        src={readyPhotoSource}
        alt=""
        diameter={diameter}
        zIndex={zIndex}
      />
    );
  if (!profilePictureFileName && isImageLoading) return <></>;

  if (!profilePictureFileName || img === '') {
    return (
      <PlaceHolderWrapper
        src={isGroup ? groupAvatar : userAvatar}
        alt=""
        diameter={diameter}
        zIndex={zIndex}
        role="placeholderPicture"
      />
    );
  }

  return <SImg role="profilePicture" src={img} alt="" diameter={diameter} zIndex={zIndex} />;
};
